import { render, staticRenderFns } from "./OrderMenu.vue?vue&type=template&id=f580d9e4&scoped=true&"
import script from "./OrderMenu.vue?vue&type=script&lang=js&"
export * from "./OrderMenu.vue?vue&type=script&lang=js&"
import style0 from "./OrderMenu.vue?vue&type=style&index=0&id=f580d9e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f580d9e4",
  null
  
)

component.options.__file = "OrderMenu.vue"
export default component.exports